<template>
  <div class="support-promise-card">
    <div class="support-promise-icon">
      <i v-if="iconClass"
         :class="iconClass">
      </i>
    </div>
    <h3 class="support-promise-heading">
      <a v-if="isValidLink"
         :target="link.target"
         :title="heading"
         :href="link.url">
        {{ heading }}
      </a>
      <template v-else>
        {{ heading }}
      </template>
    </h3>
    <p class="support-promise-description">
      {{ description }}
    </p>
    <p v-if="isValidLink"
       class="support-promise-action">
      <a class="gl-link"
         :target="link.target"
         :href="link.url"
         rel="nofollow">
        {{ link.name }}

        <font-awesome-icon
          :icon="['fal', 'chevron-right']"
          aria-hidden="true">
        </font-awesome-icon>
      </a>
    </p>
  </div>
</template>

<script>
export default {
  name: "SupportPromiseCard",
  props: {
    link: {
      type: Object,
      default: () => ( undefined ),
      validator: ( val ) => ( ["name", "url", "target"].every( ( key ) => key in val ) ),
    },
    heading: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
    iconClass: {
      type: String,
      default: null,
    },
  },
  computed: {
    isValidLink () {
      return this.link && this.link.name && this.link.url;
    },
  },
};
</script>
<style lang="less" scoped>
.support-promise {
    &-card {
      display: flex;
      flex-direction: column;
      text-decoration: none;
      color: #333;
      height: 100%;

      &:hover {
        color: #333;
        text-decoration: none;
      }
    }

    &-heading {
      > a {
        line-height: unset;
        color: unset;
        text-decoration: none;
      }
    }

    &-icon {
      font-size: 3.75rem;
      font-weight: 200;
      color: #d71920;
      margin-bottom: 20px;
      line-height: 1.2;

      @media (max-width: 767px) {
        margin-bottom: 10px;
      }
    }

    &-description {
      font-size: 1rem;
      margin-bottom: 10px;
    }

    &-action {
      margin-top: auto;
      font-weight: 500;
    }
}
</style>
